import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BasePublicSearchDto } from '../../../shared/modules/base/dtos/base-public-search.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { AreaTypeEnum } from '../../../shared/modules/settings/enums/area-type.enum';
import { MapCoordinateDto } from '../../../shared/modules/shared/dtos/map-coordinate.dto';
import { LocationTypeEnum } from '../enums/location-type.enum';

/**
 * Location DTO for public searchable fields
 */
@CaslSubject(AppSubjectEnum.LOCATION)
export class LocationPublicSearchDto extends BasePublicSearchDto {
  name!: string;
  addressFull?: string | null;
  type!: LocationTypeEnum;
  areaName!: string;
  areaType!: AreaTypeEnum;
  isPickUp?: boolean | null;
  isDropOff?: boolean | null;
  isPrivate?: boolean | null;
  gpsCoordinates!: MapCoordinateDto;
  files?: FileDto[] | null;
}
